export default __webpack_public_path__ + "static/media/d317141e36097ac5.6124e8a3c21483d5689e5b0234d21a92.svg";